import { of } from 'rxjs'
import { isEqual } from 'lodash-es'
import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { catchError, distinctUntilChanged, map, switchMap } from 'rxjs/operators'

import { queueMap } from 'src/services/data/utils'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { CreditNotesElasticSearchService } from 'src/services/data/credit-note-elastic.service'
import { prepareFiltersPayload, prepareCreditNotesPayload } from './credit-notes-view-filters.utils'
import { TOP_LEVEL_FILTERS } from 'src/components/credit-notes/credit-notes-list/credit-notes-list.filters'
import { loadCreditNoteViews, loadCreditNoteViewsFailure, loadCreditNoteViewsSuccess, loadCreditNoteFilters, loadCreditNoteFiltersSuccess, loadCreditNoteFiltersFailure } from './credit-notes-view.actions'

@Injectable()
export class CreditNoteViewEffects {
  private actions$ = inject(Actions)
  private toaster = inject(ToasterService)
  private elastic = inject(CreditNotesElasticSearchService)


  loadCreditNoteViews$ = createEffect(() => this.actions$.pipe(
    ofType(loadCreditNoteViews),
    map(action => ({
      action,
      payload: prepareCreditNotesPayload(action.filters, action.page),
    })),
    queueMap(({action, payload}) =>
      this.elastic.search({ ...payload, calculate: action.calculate }).pipe(
        map(r => loadCreditNoteViewsSuccess({
          tableKey: action.tableKey,
          total: r.total,
          creditNoteViews: r.data,
          payload,
          totals: {}
        })),
        catchAndLog(this.toaster, 'Unable to fetch credit notes', loadCreditNoteViewsFailure
      )))))

  loadCreditNoteFilters$ = createEffect(() => this.actions$.pipe(
    ofType(loadCreditNoteFilters),
    map(action => ({
      tableKey: action.tableKey,
      payload: prepareFiltersPayload(action.filters, TOP_LEVEL_FILTERS[action.tableKey]),
    })),
    distinctUntilChanged(isEqual),
    switchMap(({tableKey, payload}) => this.elastic.filters(payload).pipe(
      map(result => loadCreditNoteFiltersSuccess({ tableKey, result })),
      catchError(error => of(loadCreditNoteFiltersFailure({ error }))),
    ))))
}